import * as yup from 'yup';


export const loginFormValidation = yup.object().shape(
  {
    username: yup
                .string()
                .email()
                .required(),
    password: yup
                .string()
                .required(),
  },
);


export const forgotPasswordEmailFormValidation = yup.object().shape(
  {
    email: yup
             .string()
             .email()
             .required(),
  },
);


export const forgotPasswordSecurityAnswerFormValidation = (answer: string) => yup.object().shape(
  {
    answer: yup
              .string()
              .matches(new RegExp(`^${answer}$`))
              .required(),
  },
);


export const newPasswordFormValidation = (
  reqsNotMet: string,
  fieldsDoNotMatch: string,
  minLength?: number,
  requireSymbol?: boolean,
) => yup.object().shape(
  {
    password: yup
              .string()
              .min(minLength ?? 8, reqsNotMet) // Minimum 8 characters unless client-specified
              .matches(requireSymbol ?? false
                ? new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ !"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~]).*$')
                : new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$')
              , reqsNotMet)
    //TODO - does this work for all languages?
                       .required(reqsNotMet),
    confirmPassword: yup
                       .string()
                       .oneOf([yup.ref('password'), null], fieldsDoNotMatch)
                       .required(fieldsDoNotMatch),
  },
);


export const updatePasswordFormValidation = (
  password: string,
  invalidPassword: string,
  reqsNotMet: string,
  fieldsDoNotMatch: string,
  minLength?: number,
) => yup.object().shape(
  {
    currentPassword: yup
                      .string()
// TODO - may want to introduce some sort of hash strategy for password that works in javascript and C#
                      .oneOf([password], invalidPassword)
                      .required(invalidPassword),
    password:        yup
                       .string()
                       .min(minLength ?? 8, reqsNotMet) // Minimum 8 characters unless client-specified
                       .matches(new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$'), reqsNotMet)
                       .required(reqsNotMet),
    confirmPassword: yup
                       .string()
                       .oneOf([yup.ref('password'), null], fieldsDoNotMatch)
                       .required(fieldsDoNotMatch),
  },
);


export const setupSecurityQuestionFormValidation = (
  questionRequired: string,
  reqsNotMet: string,
) => yup.object().shape(
  {
    questionId: yup
                  .number()
                  .positive(questionRequired)
                  .required(questionRequired),
    answer:     yup
                  .string()
                  .matches(new RegExp(/(\S)+/), reqsNotMet)
                  .required(reqsNotMet),
  },
);